import React from 'react';
import { Wrapper, CenteredContainer, BigIcon, Title, Description } from '../StatusViews.styles';

export const Error = () => {
  return (
    <Wrapper>
      <CenteredContainer>
        <BigIcon className="far fa-times-circle" color="error.600" />
        <Title>There was an error opening your account</Title>
        <Description>An unexpected error has occurred.</Description>
      </CenteredContainer>
    </Wrapper>
  );
};
